import {
  helpers,
  email as rawEmail,
  maxLength as rawMaxLength,
  minLength as rawMinLength,
  required as rawRequired,
} from '@vuelidate/validators';

export const required = helpers.withMessage('Please complete', rawRequired);
export const email = helpers.withMessage('Please provide a valid email address', rawEmail);
export const maxLength = (max: number) => helpers.withMessage(
  `Is too long (maximum is ${max} characters)`,
  rawMaxLength(max),
);
export const minLength = (min: number) => helpers.withMessage(
  `Too short (minimum is ${min} characters)`,
  rawMinLength(min),
);
